<script>
    import { onMount } from "svelte";
    import { ICONS } from "../js/icons";
    import backend from "../server";

    import CreateFreeSpin from "../lib/components/modals/freebets/pateplay/CreateFreeSpin.svelte";
    import FromCancelFree from '../lib/components/modals/freebets/pateplay/FromCancelFree.svelte';
    import FromShowDetailFree from '../lib/components/modals/freebets/pateplay/FromShowDetailFree.svelte'
    import BonusStakeGenerator from '../lib/components/modals/freebets/pateplay/BonusStakeGenerator.svelte'
    import Pagination from '../lib/components/modals/freebets/novus/Pagination.svelte';
    
  
    let currentPage = 1;
    let totalPages = 1;
    let lastBonusId = null;
  
  
    let filters = { page: 1, xpage: 5000 };
    let platforms = [];
    let platform = {};

    let showNewFreeSpin = false;
    let isshowDetail = false;
    let bonuses = [];
    let isLoading = true;
    let bonusSelect = "";
    let showFilters = false;
    let isStake=false;
  
    onMount(() => {
      listBonuses();
      getCountBonuses();
    });
  
    const searchEnter = (e) => {
      if (e.charCode === 13);
    };
  

  
  const getCountBonuses = async()=>{
   /* const payload = {
        limit: 1000,
        startId: lastBonusId || null,
        siteCode: 'universalsoft'
      };
    isLoading = true; 
      let response = await backend.freespin.listFreeSpinsPP(payload);
      let result = response.data.result.bonuses;
      totalPages = Math.ceil(result.length / 10);*/
  }
  
    const listBonuses = async () => {
      const payload = {
        limit: 10000,
        startId: lastBonusId || null,
        siteCode: 'latinsport21'
      };
      isLoading = true; 
      let response = await backend.freespin.listFreeSpinsPP(payload);
      console.log("response: ", response);
      bonuses = response.data.result.bonuses;
      lastBonusId = 0;//bonuses.length > 0 ? bonuses[bonuses.length - 1].bonusId : null;
      isLoading = false; 
    };
  
    function handlePageChange(page) {
      if (page === currentPage) return;
      currentPage = page;
      listBonuses();
    }
  
    const onNewFreeSpin = () => {
      showNewFreeSpin = true;
    };
  
  
   
    const detalls = (bonusId) => {
     bonusSelect=bonusId;
     isshowDetail = true;
    };
  
    let isCancel =false;
    const cancel = () => {
      isCancel = true;
    };
  
    const stakeGenerator = () => {
      isStake = true;
    };
   
    const toggleFilters=()=>{
      showFilters = !showFilters;
    }
  

      let statusMap = {
      10: { label: "PENDIENTE", class: "bg-warning" },
      20: { label: "CLAIMED", class: "bg-info" }, 
      30: { label: "READY", class: "bg-success-light" },
      40: { label: "EN_JUEGO", class: "bg-primary" },
      90: { label: "CANCELADO", class: "bg-danger" },
      95: { label: "EXPIRADO", class: "bg-secondary" },
      100: { label: "COMPLETADO", class: "bg-success" }
  };

  
  </script>
  <div class="wrapp">
    <div class="menu-filter">
      <div style="display: flex; flex-direction: row; gap: 0.5rem; margin-top: 1rem;">
    
      <!-- Barra de búsqueda y botones -->
        <input
          on:keypress={searchEnter}
          bind:value={filters.search}
          class="form-control"
          placeholder="Buscar"
          style="flex: 1;" 
        />
    
        <!-- Botón de búsqueda -->
        <button
        on:click={listBonuses}
        class="btn btn-pink btn-sm"
        title="Buscar"
        disabled={isLoading} >
        {#if isLoading}
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cargando...
        {:else}
          {@html ICONS.search}
        {/if}
      </button>
      
        <!-- Botón para nuevo -->
        <button class="btn btn-pink btn-sm" on:click={onNewFreeSpin}>
          {@html ICONS.add}
        </button>
          <!-- Botón para toggle de filtros -->
        <button class="btn btn-pink btn-sm" on:click={toggleFilters}>
          <i class="fa-solid {showFilters ? 'fa-filter-circle-xmark':'fa-filter'}"></i>
        </button>
          <!-- Botón cancel-->
          <button class="btn btn-pink btn-sm" on:click={cancel}>
            <i class="fa-solid fa-circle-xmark"></i>
          </button>
  
           <!-- Botón Generate all valid bonus stakes for games-->
           <button class="btn btn-pink btn-sm" on:click={stakeGenerator}>
            {@html ICONS.games}
          </button>
  
      </div>
    </div>
    </div>
  
  <div class="wrapp">
    <div class="menu-filter">
      {#if showFilters}
      <div class="filter-games">
        <span>Plataforma:</span>
        <div style="display: flex; flex-direction: row; gap: 0.5rem;">
          <select bind:value={filters.clientId} class="form-control">
            <option value="">Todos</option>
            {#each platforms as platform}
              <option value={platform.clientId}>{platform.name}</option>
            {/each}
          </select>
        </div>
      </div>
      <div class="filter-games">
      </div>
      {/if}
    </div>
  </div>
  
    <div class="wrapp">
    <div class="container-table">
      <div style="overflow-x: auto;">
      
        {#if isLoading}
        <p>Cargando...</p>
      {:else}
        {#if bonuses.length > 0}
          <table class="table table-sm">
            <thead>
              <tr>
                <th>N°</th>
                <th>Bonus ID</th>
                <th>Referencia</th>
                <th>Jugador</th>
                <th>Moneda</th>
                <th>Tipos</th>
                <th>Tiempo Expiración</th>
                <th>General Tiempo Expiración</th>
                <th>Estado</th>
                <th colspan="2">Action</th>  
              </tr>
            </thead>
            <tbody>
              {#each bonuses as bonus, index}
                <tr>
                  <td>{index + 1}</td> 
                  <td>{bonus.bonusId}</td>
                  <td>{bonus.campaignRef ? bonus.campaignRef : 'N/A'}</td>
                  <td>{bonus.playerId}</td>
                  <td>{bonus.currency}</td>
                  <td>{bonus.type}</td>
                  <td>{bonus.timeExpires}</td>
                  <td>{bonus.generalTimeExpires}</td>
                  <td>
                    <span class={`badge ${statusMap[bonus.status]?.class || 'bg-dark'}`}>
                      {statusMap[bonus.status]?.label || 'Desconocido'}
                    </span>
                  </td>
                  <td>
                    <div class="button-container">
                      <button on:click={() => detalls(bonus.bonusId)} class="btn btn-secondary btn-sm">
                        {@html ICONS.eye}
                      </button>                    
                    </div>
                  </td>
  
                </tr>
              {/each}
            </tbody>
          </table>
        {:else}
          <p>No se encontraron registros.</p>
          <p style="text-align: center; color: red;"></p>
        {/if}
  
        {#if totalPages > 1}
        <Pagination 
          currentPage={currentPage} 
          totalPages={totalPages} 
          onPageChange={handlePageChange}
        />
      {/if}
      {/if}
        
      </div>
    </div>
  </div>
  

  {#if showNewFreeSpin}
    <CreateFreeSpin bind:showNewFreeSpin></CreateFreeSpin>
  {/if}
  
  {#if isCancel}
    <FromCancelFree bind:isCancel ></FromCancelFree>
  {/if}
  {#if isshowDetail}
    <FromShowDetailFree bind:isshowDetail bind:bonusSelect ></FromShowDetailFree>
  {/if}
  
  {#if isStake}
    <BonusStakeGenerator bind:isStake></BonusStakeGenerator>
  {/if}
  
  
  
  
  <style>
    .menu-filter {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
      padding: 0.5rem;
    }
    .button-container {
      display: flex;
      gap: 10px; /* Esto crea un margen de 10px entre los botones */
    }
    .container-table {
      padding: 0.5rem;
    }
  
    .btn-pink {
     background-color: #2a1a28;
      color: white;
    }
    .btn-pink:hover{
        background-color: #FF0090;
      color: white;
    }
    .wrapp {
    padding: 10px;
    margin: 0;
  }
  
  .menu-filter {
    margin: 0;
    padding: 0;
  }
  
  
  
  
  </style>
  